import React, { useState } from 'react'
import TagManager from 'react-gtm-module'
import { NavLink } from "react-router-dom"
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Title from './Title';
import Description from './Description';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';

const RegisterForm = () => {
  const [referralCode, setReferralCode] = useState('');
  const [showMessage, setShowMessage] = useState(false);

  const handleJoinNow = (e: React.MouseEvent) => {
    e.preventDefault();
    
    if (referralCode.trim()) {
      setShowMessage(true);
    }
    // If no referral code, do nothing (just prevent default navigation)
  }

  return (
    <div className='login-form-box'>
      {/* <img src='../images/logo.png' className='register-page-logo' /> */}
      <Title
        textAlign="center"
        textColor="black"
        fontSize="30px"
        fontWeight="400"
        content="Referral code needed."
      />
      <br />
      <Description 
        textColor="black"
        textAlign="center"
        content="DressTwin is a invite only community for fashion addicts."
        // subContent="Early birds may request code via form."
      />
      <form className='login-form register-page'>
        <TextField 
          id="outlined-basic" 
          label="Please enter referral code" 
          variant="outlined" 
          fullWidth={true}
          value={referralCode}
          onChange={(e) => setReferralCode(e.target.value)}
        />
        {showMessage && (
          <div style={{ color: 'orange', fontSize: '14px', textAlign: 'center', marginTop: '10px', padding: '10px', backgroundColor: '#fff8e1', borderRadius: '4px', border: '1px solid #ffcc02' }}>
            Please check your referral code. If the code is valid, you will receive access instructions shortly.
          </div>
        )}
        <button type="button" onClick={handleJoinNow} className='form-link already-registered' style={{ textDecoration: 'none', color: 'black', display: 'flex', alignItems: 'center', background: 'none', border: 'none', cursor: 'pointer' }}>
          <span>Join now</span>
          <NavigateNextIcon />
        </button>
        <NavLink to="/" className='form-link already-registered'>
          <span>Already registered? Login</span>
          <NavigateNextIcon />
        </NavLink>
        <Button
            type="button"
            onClick={(e) => {
              e.preventDefault();

              TagManager.dataLayer({
                dataLayer: {
                    event: 'event_RegisterJoinNowBtnClick'
                }
             });

              window.location.href='https://getwaitlist.com/waitlist/28912';
              }}
            variant="contained" size="large" fullWidth={true}>request code
          </Button>
      </form>
    </div>
  )
};

export default RegisterForm